import { useNavigate } from "react-router-dom";
import { useUser } from "../userContext/UserContext";

export function useLogout() {
  const navigate = useNavigate();
  const { setUserData } = useUser();

  const logout = () => {
    localStorage.removeItem("harenaCowonder");
    localStorage.removeItem("harenaCowonderAuth");
    localStorage.removeItem("authToken");
    setUserData(null);
    navigate("/login");
  };

  return logout;
}
